  <!-- Main Content -->
  <div class="p-5 bg-white shadow-md lg:col-span-3 rounded-2xl">
    <div class="flex items-center space-x-3">
      <button class="text-2xl text-gray-700" (click)="goToPrevStep(2)">
        <i class="ri-arrow-left-long-line"></i>
      </button>
      <h2 class="text-2xl font-semibold text-gray-900 font-raleway">
        Let’s get your personal information
      </h2>
    </div>
    <p class="mt-2 text-base leading-6 text-gray-500 font-raleway">
      We will use these details to keep you informed on the status of your order!
    </p>

  <!-- Form Fields -->
  <form class="checkout-form">
    <!-- Name Fields -->
    <div class="grid grid-cols-1 gap-5 md:grid-cols-2">
      <div class="w-full">
        <label
          for="first-name"
          class="block mb-1 text-sm font-medium text-gray-700 font-raleway">
          First name
        </label>
        <input
          pInputText
          id="first-name"
          type="text"
          placeholder="Enter your first name"
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>
      <div class="w-full">
        <label
          for="last-name"
          class="block mb-1 text-sm font-medium text-gray-700 font-raleway">
          Last name
        </label>
        <input
          pInputText
          id="last-name"
          type="text"
          placeholder="Enter your last name"
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>
    </div>

    <!-- Email Address -->
    <div class="mt-4">
      <label
        for="email"
        class="block mb-1 text-sm font-medium text-gray-700 font-raleway">
        Email address
      </label>
      <input
        pInputText
        id="email"
        type="email"
        placeholder="Enter your email"
        class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
    </div>

    <!-- Phone Numbers -->
    <div class="grid grid-cols-1 gap-5 mt-4 md:grid-cols-2">
      <div class="w-full">
        <label
          for="mobile-phone"
          class="block mb-1 text-sm font-medium text-gray-700 font-raleway">
          Mobile phone number
        </label>
        <input
          pInputText
          id="mobile-phone"
          type="tel"
          placeholder="Enter phone number"
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>
      <div class="w-full">
        <label
          for="home-phone"
          class="block mb-1 text-sm font-medium text-gray-700 font-raleway">
          Home phone number
        </label>
        <input
          pInputText
          id="home-phone"
          type="tel"
          placeholder="Enter phone number"
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>
    </div>

      <!-- Marketing Checkbox -->
      <div class="flex items-center p-3 my-4 border border-gray-300 rounded-md">
        <input type="checkbox" id="termsAccepted" [(ngModel)]="termsAccepted" />
        <label for="termsAccepted" class="block">
          <p class="ml-4 text-sm text-gray-700">
            Sign me up for marketing communications related to this order!
          </p>
        </label>
      </div>
      <button
      pButton
      type="button"
      class="w-40 h-12 px-6 py-3 mt-10 text-sm font-medium text-white transition bg-blue-600 rounded-lg font-raleway hover:bg-blue-700">
      Submit
    </button>
    </form>
  </div>
